export default __webpack_public_path__ + "3975b538ca0bee39dc6da26a24d1d4cd.svg";